import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  where,
} from 'firebase/firestore';
import { db } from '@/cloud/config/firebaseConfig';
import { COLLECTION } from '@/utils/constant';

const projectRef = () => collection(db, COLLECTION.PROJECT);
const projectDocRef = (id) => doc(db, COLLECTION.PROJECT, id);

export const projectDocs = async () => {
  const docsRef = query(projectRef(), where('show', '==', true));
  const snashot = await getDocs(docsRef);
  const docs = snashot.docs
    .map((doc) => doc.data())
    .sort((a, b) => {
      if (a.period.end && b.period.end) {
        return b.period.end - a.period.end;
      } else if (a.period.end || a.period.end) {
        return a.period.end ?? -1;
      } else {
        return b.period.start - a.period.start;
      }
    });
  return docs;
};

export const projectDoc = async (id) => {
  const doc = await getDoc(projectDocRef(id));
  return doc.exists() ? doc.data() : null;
};
